import React from 'react';
import './About.css';

const About = () => (
  <section className="about-page">
    <div className="about-container fade-in">
      <h2>About Harrygen Labs</h2>
      <p>
        Harrygen Labs is a forward-thinking pharmaceutical company committed to transforming healthcare with innovative and reliable formulations. 
        Our core philosophy revolves around making high-quality, affordable medicines accessible across India.
      </p>

      <div className="about-values">
        <div className="value-card slide-up">
          <h3>🧬 Innovation-Driven</h3>
          <p>
            We invest in continuous research and product development to ensure our offerings meet global quality standards and patient needs.
          </p>
        </div>
        <div className="value-card slide-up" style={{ animationDelay: '0.2s' }}>
          <h3>🌐 Growing Nationwide</h3>
          <p>
            With a rapidly expanding footprint, we are making our presence felt in multiple states across India through trusted partnerships and distribution networks.
          </p>
        </div>
        <div className="value-card slide-up" style={{ animationDelay: '0.4s' }}>
          <h3>🤝 Built on Trust</h3>
          <p>
            Our commitment to ethics, transparency, and quality builds long-term trust with healthcare professionals and patients alike.
          </p>
        </div>
      </div>

      <p>
        Backed by a passionate team and modern infrastructure, Harrygen Labs strives to deliver excellence at every step — from manufacturing to marketing.
        Our focus remains on creating products that improve lives and support a healthier future for communities everywhere.
      </p>
    </div>

    <div className="ceo-message fade-in">
      <h3>Message from the CEO</h3>
      <p>
        At Harrygen Labs, we believe in redefining healthcare through innovation, integrity, and dedication. 
        Our mission is not just to manufacture pharmaceutical products, but to build a healthier tomorrow for every life we touch. 
        We are committed to quality, trust, and transparency in everything we do.
      </p>
      <p>
        Thank you for believing in us. Together, let's move toward a future of accessible and effective healthcare solutions.
      </p>
      <span className="ceo-signature">— CEO, Harrygen Labs</span>
    </div>
  </section>
);

export default About;
